import { render, staticRenderFns } from "./ProfileTimeline.vue?vue&type=template&id=04f79258&scoped=true"
import script from "./ProfileTimeline.vue?vue&type=script&lang=js"
export * from "./ProfileTimeline.vue?vue&type=script&lang=js"
import style0 from "./ProfileTimeline.vue?vue&type=style&index=0&id=04f79258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f79258",
  null
  
)

export default component.exports